import React from 'react';
import type { SpellSanityCostBreakdown } from '../api';

const value = (number: number | null) => number == null ? 'X' : number;
const signed = (number: number) => number < 0 ? `−${Math.abs(number)}` : `+${number}`;

export const SpellCostBreakdown: React.FC<{ breakdown: SpellSanityCostBreakdown }> = ({ breakdown }) => {
  const adjustedFloor = breakdown.base != null && breakdown.base + (breakdown.adjustments ?? []).reduce((sum, modification) => sum + modification.value, 0) < 0;
  const reductionFloor = breakdown.adjustedCost != null && breakdown.adjustedCost - (breakdown.automaticReductions ?? []).reduce((sum, modification) => sum + modification.value, 0) < 0;
  return <section className="spell-cost-breakdown" aria-label="Sanity cost breakdown">
    <h3>Sanity cost breakdown</h3>
    <dl>
      <div><dt>{breakdown.base == null ? 'Variable base cost' : 'Printed cost'}</dt><dd>{value(breakdown.base)}</dd></div>
      {(breakdown.adjustments ?? []).map((modification, index) => <div key={`adjust-${index}`}><dt>{modification.source}</dt><dd>{signed(modification.value)}</dd></div>)}
      <div className="spell-cost-subtotal"><dt>After cost adjustments{adjustedFloor ? ' (minimum 0)' : ''}</dt><dd>{value(breakdown.adjustedCost)}</dd></div>
      {(breakdown.automaticReductions ?? []).map((modification, index) => <div key={`reduce-${index}`}><dt>{modification.source}</dt><dd>{signed(-modification.value)}</dd></div>)}
      <div className="spell-cost-total"><dt>Automatic Sanity cost{reductionFloor ? ' (minimum 0)' : ''}</dt><dd>{value(breakdown.total)}</dd></div>
    </dl>
    {breakdown.base == null && <p>The final cost is clamped to a minimum of 0 after each stage.</p>}
    {(breakdown.notes ?? []).map((note, index) => <p key={index}>{note}</p>)}
  </section>;
};
